// import React, { useState, useEffect, useContext } from 'react';
// import { NavLink, Link } from 'react-router-dom';
// import './Header.css';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faMinus, faFont, faPlus, faUser } from '@fortawesome/free-solid-svg-icons';
// import logo from '../assets/logo_01.gif';
// import { GlobalContext } from '../contexts/GlobalContext';
// import axios from 'axios';

// function Header({ onFontSizeDecrease, onFontSizeReset, onFontSizeIncrease }) {
//    const [themeData, setThemeData] = useState(null);
//    const { isLoggedIn, userLevel } = useContext(GlobalContext);

//    useEffect(() => {
//         axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getTheme`)
//         .then((response) => {
//             setThemeData(response.data);
//         })
//         .catch((error) => {
//             console.error("There was an error fetching the data!", error);
//         });
//    }, []);

//    const lightGreen = getComputedStyle(document.documentElement).getPropertyValue('--green-light');

//    return (
//       <header className="header">
//          <NavLink to="/">
//          <img src={logo} alt="三藩市基督之家" title="三藩市基督之家" className="logo" />
//          </NavLink>
//          <div className="header-right">
//             <h2 className="theme">{themeData ? themeData : <span></span>}</h2>
//             <div className="font-size-controls">
//                <button onClick={onFontSizeDecrease} className="font-size-button" aria-label="減小字體">
//                   <FontAwesomeIcon icon={faMinus} style={{ color: lightGreen }} />
//                </button>
//                <button onClick={onFontSizeReset} className="font-size-button" aria-label="重置字體">
//                   <FontAwesomeIcon icon={faFont} style={{ color: lightGreen }} />
//                </button>
//                <button onClick={onFontSizeIncrease} className="font-size-button" aria-label="增大字體">
//                   <FontAwesomeIcon icon={faPlus} style={{ color: lightGreen }} />
//                </button>
//             </div>
//          </div>
//       </header>
    
//    );
// }

// export default Header;



// src/components/Header.js

import React, { useState, useEffect, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faFont, faPlus, faBars } from '@fortawesome/free-solid-svg-icons'; // Added faBars
import logo from '../assets/logo-hocsf.png';
import logoMobile from '../assets/logo-hocsf-mobile.png';
import { GlobalContext } from '../contexts/GlobalContext';
import MobileSidebar from './MobileSidebar';
import axios from 'axios';

function Header({ onFontSizeDecrease, onFontSizeReset, onFontSizeIncrease }) {
  const [themeData, setThemeData] = useState(null);
  const { isLoggedIn, userLevel } = useContext(GlobalContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false); // Added state for mobile menu

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/getTheme`)
      .then((response) => {
        setThemeData(response.data);
      })
      .catch((error) => {
        console.error('There was an error fetching the data!', error);
      });
  }, []);

  const lightGreen = getComputedStyle(document.documentElement).getPropertyValue('--green-light');

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <header className="header">
      {/* Burger menu icon for mobile view */}
      <div className="mobile-menu-icon">
        <FontAwesomeIcon icon={faBars} onClick={handleMobileMenuToggle} />
      </div>

      {/* Logo */}
      <NavLink to="/" className="logo-container">
        <img src={logo} alt="三藩市基督之家" title="三藩市基督之家" className="logo" />
      </NavLink>

      <NavLink to="/" className="logo-container-mobile">
        <img src={logoMobile} alt="三藩市基督之家" title="三藩市基督之家" className="logo-mobile" />
      </NavLink>

      {/* Header Right Section */}
      <div className="header-right">
        {themeData ? <h2 className="theme" dangerouslySetInnerHTML={{ __html: themeData }}></h2> : <h2></h2>}
        <div className="font-size-controls">
          <button onClick={onFontSizeDecrease} className="font-size-button" aria-label="減小字體">
            <FontAwesomeIcon icon={faMinus} style={{ color: lightGreen }} />
          </button>
          <button onClick={onFontSizeReset} className="font-size-button" aria-label="重置字體">
            <FontAwesomeIcon icon={faFont} style={{ color: lightGreen }} />
          </button>
          <button onClick={onFontSizeIncrease} className="font-size-button" aria-label="增大字體">
            <FontAwesomeIcon icon={faPlus} style={{ color: lightGreen }} />
          </button>
        </div>
      </div>

      {/* Mobile Sidebar */}
      {isMobileMenuOpen && <MobileSidebar onClose={handleMobileMenuToggle} />}
    </header>
  );
}

export default Header;
